import { render, staticRenderFns } from "./CreateUploadedVideoInterview.vue?vue&type=template&id=07f20ee8&scoped=true&"
import script from "./CreateUploadedVideoInterview.vue?vue&type=script&lang=js&"
export * from "./CreateUploadedVideoInterview.vue?vue&type=script&lang=js&"
import style0 from "./CreateUploadedVideoInterview.vue?vue&type=style&index=0&id=07f20ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f20ee8",
  null
  
)

/* custom blocks */
import block0 from "./CreateUploadedVideoInterview.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./CreateUploadedVideoInterview.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSwitch,VTextField})
